import { type ServiceMethod } from '@/application/interfaces/service';

export type OptinSource =
  | 'emailOptin'
  | 'directMailOptin'
  | 'adhesionOptin'
  | 'phoneNumberOptin'
  | 'profilingOptin'
  | 'pushNotificationOptin'
  | 'smsOptin'
  | 'whatsAppOptin';

export type GetOptinParams = {
  token: string;
  source: OptinSource;
};

export type GetOptinResponse = {
  data: {
    type: string;
    indicator: boolean;
  };
};

const getOptin: ServiceMethod<GetOptinResponse, GetOptinParams> =
  (httpClient) => async (data, options) => {
    const { body } = await httpClient.get<
      GetOptinResponse,
      undefined,
      GetOptinParams
    >('/api/v3/inhabitants/optins', {
      ...options,
      searchParams: data,
    });

    return body;
  };

export default getOptin;
